import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useFilterEditorClassNames } from './hooks/useFilterEditorClassNames';
import { useFilterEditor } from './hooks/useFilterEditor';
import { FilterEditorRoot, FilterEditorHeader, FilterEditorConditions, FilterEditorActions } from './style';
import { FILTER_EDITOR_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
import { Typography } from '../../Typography';
import { Link } from '../../Link';
import { Button, FormField } from '../..';
import { getDefaultConditionRenderer } from './utils/getDefaultConditionRenderer';
export var FilterEditor = forwardRef(function FilterEditor(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(FILTER_EDITOR_CLASS_PREFIX);
  var classNames = useFilterEditorClassNames(FILTER_EDITOR_CLASS_PREFIX, className);

  var _useFilterEditor = useFilterEditor(props, ref),
      rootProps = _useFilterEditor.rootProps,
      getConditionProps = _useFilterEditor.getConditionProps,
      schema = _useFilterEditor.schema,
      headerProps = _useFilterEditor.headerProps,
      conditionsProps = _useFilterEditor.conditionsProps,
      clearFilterButtonProps = _useFilterEditor.clearFilterButtonProps,
      getApplyFilterButtonProps = _useFilterEditor.getApplyFilterButtonProps,
      getCloseButtonProps = _useFilterEditor.getCloseButtonProps,
      getConditionType = _useFilterEditor.getConditionType,
      showCloseButton = _useFilterEditor.showCloseButton,
      showSeparatedActions = _useFilterEditor.showSeparatedActions,
      showInlineActions = _useFilterEditor.showInlineActions,
      showResultCount = _useFilterEditor.showResultCount,
      showResultTotalCount = _useFilterEditor.showResultTotalCount,
      resultCountFormatted = _useFilterEditor.resultCountFormatted,
      resultTotalCountFormatted = _useFilterEditor.resultTotalCountFormatted,
      getResultCountProps = _useFilterEditor.getResultCountProps;

  return React.createElement(FilterEditorRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), React.createElement(FilterEditorHeader, Object.assign({}, headerProps, {
    theme: theme,
    className: classNames.Header
  }), React.createElement(Typography, {
    sectionTitle: true,
    tag: "div",
    className: classNames.HeaderTitle
  }, "Filter by"), React.createElement(Link, Object.assign({
    small: true
  }, clearFilterButtonProps, {
    className: classNames.HeaderClearAllButton,
    marginLeft: 6
  }), "Clear all")), React.createElement(FilterEditorConditions, Object.assign({}, conditionsProps, {
    theme: theme,
    className: classNames.Conditions
  }), schema.conditions.map(function (condition) {
    if (!condition.id) {
      return null;
    }

    var ConditionRenderer = getDefaultConditionRenderer(getConditionType(condition));
    var conditionProps = getConditionProps(condition, condition.name || condition.id);
    return React.createElement(FormField, {
      key: condition.name,
      className: classNames.Condition,
      "data-path": condition.name
    }, React.createElement(ConditionRenderer, Object.assign({}, conditionProps)));
  }), showInlineActions && React.createElement(Button, Object.assign({}, getApplyFilterButtonProps(), {
    className: classNames.ApplyButton,
    secondary: true
  }), "Apply")), showResultCount && React.createElement(Typography, Object.assign({}, getResultCountProps(), {
    className: classNames.ResultCount
  }), "showing ", resultCountFormatted, ' ', showResultTotalCount ? "out of ".concat(resultTotalCountFormatted) : '', ' ', "results"), showSeparatedActions && React.createElement(FilterEditorActions, {
    theme: theme,
    className: classNames.Actions
  }, showCloseButton && React.createElement(Button, Object.assign({
    secondary: true,
    marginRight: 4
  }, getCloseButtonProps(), {
    className: classNames.CloseButton
  }), "Close"), React.createElement(Button, Object.assign({
    wide: true
  }, getApplyFilterButtonProps(), {
    className: classNames.ApplyButton
  }), "Apply")));
});
FilterEditor.defaultProps = {};